import { useState } from 'react';
import destImages from '../destImages';

// Drop-in absolute-positioned hero image. The parent must be `relative`.
// Shows the destImages URL if we have one, otherwise renders an inline
// brand gradient placeholder with the city's initials. If the URL 404s,
// we swap to the placeholder so the card never shows a blank box.
export default function DestImage({ city, alt, imgClassName = '' }) {
  const url = destImages[city] || '';
  const [errored, setErrored] = useState(false);
  const showImage = url && !errored;

  if (showImage) {
    return (
      <img
        src={url}
        alt={alt || city}
        loading="lazy"
        onError={() => setErrored(true)}
        className={`absolute inset-0 w-full h-full object-cover ${imgClassName}`}
      />
    );
  }
  return <FallbackTile city={city} />;
}

function FallbackTile({ city }) {
  const initials =
    (city || '?')
      .split(/[+,\s]+/)
      .filter(Boolean)
      .slice(0, 2)
      .map((s) => s[0]?.toUpperCase())
      .join('') || '?';

  const palettes = [
    ['#5993F7', '#182185'],
    ['#5091E9', '#3a78d2'],
    ['#182185', '#5091E9'],
    ['#5993F7', '#5091E9'],
  ];
  const hash = (city || '').split('').reduce((a, c) => a + c.charCodeAt(0), 0);
  const [c1, c2] = palettes[hash % palettes.length];

  return (
    <div
      className="absolute inset-0 flex items-center justify-center"
      style={{ background: `linear-gradient(135deg, ${c1} 0%, ${c2} 100%)` }}
    >
      <span className="text-brand-cream text-4xl font-extrabold tracking-tight opacity-90 select-none">
        {initials}
      </span>
    </div>
  );
}
